import { useRef, useState, useEffect, type ReactNode } from "react";

/**
 * Defers rendering of children until the wrapper scrolls into view.
 * Uses IntersectionObserver with a generous rootMargin so content
 * is ready before the user actually reaches it.
 */
const LazySection = ({
  children,
  rootMargin = "400px",
  className,
}: {
  children: ReactNode;
  rootMargin?: string;
  className?: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div ref={ref} className={className}>
      {visible ? children : null}
    </div>
  );
};

export default LazySection;
